<template>
  <div>
    <mt-header fixed title="fixed top"></mt-header>

  </div>
</template>

<script>
export default {
name: "index.vue"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/pomelo/app/task/index.vue